export default __webpack_public_path__ + "static/media/nodejs-icon.38883f9d.svg";